/**
 * Header component
 */

import * as React from "react";
import { Link } from "gatsby";
import MainMenu from "./main-menu";
import Search from "./search"
const searchIndices = [{ name: `Pages`, title: `Pages` }, { name: `Posts`, title: `Posts` },  { name: `Resources`, title: `Resources` },  { name: `Staff`, title: `Staff` } ]

const Header = () => {
  return (
    <header className="bg-white lg:sticky lg:top-0 lg:z-20 shadow-lg transition-all">
      <a href="#main-content" className="sr-only">
        Skip to main content
      </a>

      <div className="container py-4 sm:py-2 lg:py-3 2xl:py-4 flex flex-wrap justify-between items-center">
        <Link to="/" className="xl:mr-4">
          <img
            loading="lazy"
            className="w-32 sm:w-44 grow"
            src="/images/CommunityFoundationLogo.svg"
            alt="Community Foundation of Northern Nevada Logo"
          />
        </Link>
        <MainMenu />
        <Search indices={searchIndices} />
      </div>
    </header>
  );
};

export default Header;
